import React from 'react'
// import { Button, Form, Input, Select, Radio } from 'antd'
import { Time} from '@/components'
// mobx
import { useStore } from '@/store'
// import { set, runInAction, toJS } from 'mobx'
import { observer } from 'mobx-react-lite'
// mobx

const DhspInput2 = () => {
  // const { DhspStore } = useStore()
  return (
    <>
      视频回放
     <Time></Time>
    </>
  )
}

export default observer(DhspInput2)